/* YG Home — Category carousel: hover/click state, ported from source.
   Confirmed from nss-carousel.js.download (not assumed): each slide gets
   its own mouseenter/mouseleave toggling .is-hover, and a SEPARATE click
   listener toggling .is-open — two distinct states, two distinct triggers.
   Both call the carousel's own swiper.update() ~500ms later, since the
   class change animates a width transition (.4s) that changes this
   slidesPerView:"auto" carousel's internal slide-position math; the delay
   matches source (setTimeout 500ms) so it fires after the transition ends,
   not mid-animation.
   Reference has no keyboard equivalent for .is-open (confirmed: no keydown
   or tabindex handling anywhere in nss-carousel.js.download) — not invented
   here either. */
(function () {
  'use strict';

  function initCards(root) {
    var carouselRoot = root.querySelector('[data-yg-carousel-root]');
    root.querySelectorAll('.yg-cat__card').forEach(function (card) {
      if (card.__ygCatInit) return;
      card.__ygCatInit = true;

      function updateSwiperLater() {
        setTimeout(function () {
          if (carouselRoot && carouselRoot.__ygSwiper) carouselRoot.__ygSwiper.update();
        }, 500);
      }

      // Desktop only. Below 990px the carousel is disabled and the cards are
      // a plain two-column grid whose only job is to link to the collection,
      // and none of this state applies there: .is-hover and .is-open are both
      // styled inside the min-width:990px block, so the classes went on and
      // off with nothing to show for it.
      //
      // Worse, every tap also queued swiper.update() on the disabled
      // instance, which re-applies Swiper's own layout and pointer handling
      // over the grid fallback -- so a tap meant for the card's link was
      // being spent on state no one could see.
      //
      // Checked per event rather than once at init: a phone rotated into
      // landscape, or a desktop window dragged narrow, crosses this width
      // without re-running init.
      function isCarouselWidth() {
        return window.matchMedia('(min-width: 990px)').matches;
      }

      card.addEventListener('mouseenter', function () {
        if (!isCarouselWidth()) return;
        card.classList.toggle('is-hover');
        updateSwiperLater();
      });
      card.addEventListener('mouseleave', function () {
        if (!isCarouselWidth()) return;
        card.classList.toggle('is-hover');
        updateSwiperLater();
      });
      card.addEventListener('click', function (e) {
        if (!isCarouselWidth()) {
          // Below 990px the card is a linked grid tile. It carries a
          // full-card overlay <a> for that, but the overlay depends on
          // stretching to a box whose height comes from an aspect-ratio
          // pseudo-element inside a grid item -- and on real phones that has
          // not been reliable, leaving taps landing on the card with nothing
          // to follow.
          //
          // So drive it from the card itself, which is the element actually
          // being tapped. The overlay stays as the accessible, real link
          // (keyboard, focus, middle-click, "open in new tab", and the URL on
          // long-press all need an href); this only covers the plain tap it
          // was missing.
          var link = card.querySelector('.yg-cat__mob-link');
          if (!link || !link.getAttribute('href') || link.getAttribute('href') === '#') return;
          // Let a real click on any link or button through untouched --
          // including the overlay itself when it does receive the tap, which
          // would otherwise be navigated twice.
          if (e.target.closest('a, button')) return;
          window.location.href = link.getAttribute('href');
          return;
        }
        card.classList.toggle('is-open');
        updateSwiperLater();
      });
    });
  }

  /* Mobile shows the first four categories; this uncovers the rest.
     The label is swapped both ways so the button can put them back, rather
     than being a one-way door that leaves a dead control on the page. */
  function initMore(section) {
    var btn = section.querySelector('[data-yg-cat-more]');
    if (!btn || btn.__ygCatMore) return;
    btn.__ygCatMore = true;

    var more = btn.textContent.trim();
    var less = btn.getAttribute('data-less-label') || 'See less';

    btn.addEventListener('click', function () {
      var open = section.classList.toggle('is-expanded');
      btn.textContent = open ? less : more;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      // The carousel is disabled at this width, so the grid is plain CSS and
      // needs no re-measure. On the way back in, though, the cards that just
      // disappeared may have been below the fold -- bring the section's own
      // top back into view so the page doesn't jump to somewhere past it.
      if (!open) {
        var top = section.getBoundingClientRect().top;
        if (top < 0) section.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }
    });
  }

  function init(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-yg-cat]').forEach(function (section) {
      initCards(section);
      initMore(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
